import React, { useState } from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useTutorialChapters, { lessonsByIds } from '../../system/tutorials/useTutorialChapters';
import TutorialDialog from '../../../components/tutorial-help/TutorialDialog';
import bannerStyles from '../../../components/tutorial-help/TutorialsBanner.module.css';

// Lições do capítulo "Equipe e conta" (ids fixos em /data/tutorials.json)
const TEAM_LESSONS = ['papeis-da-equipe', 'convidar-equipe'];

/**
 * Para quem escolheu "Tenho equipe" na configuração inicial: apresenta o que a
 * equipe pode fazer, em vídeo, sem pedir convite agora. Some se as lições não carregarem.
 */
function TeamTutorialBanner() {
  const { chapters } = useTutorialChapters();
  const [open, setOpen] = useState(false);
  const lessons = lessonsByIds(chapters, TEAM_LESSONS);

  if (lessons.length === 0) return null;

  return (
    <>
      <button type="button" className={bannerStyles.banner} onClick={() => setOpen(true)}>
        <span className={bannerStyles.play}><GroupsIcon /></span>
        <span className={bannerStyles.body}>
          <strong className={bannerStyles.title}>Sua equipe na Gabriela</strong>
          <span className={bannerStyles.text}>
            Veja os papéis, o que cada pessoa acessa e como dar acesso. Convide quando quiser, em Usuários.
          </span>
        </span>
        <span className={bannerStyles.cta}>
          Assistir agora
          <ArrowForwardIcon fontSize="small" />
        </span>
      </button>
      <TutorialDialog open={open} onClose={() => setOpen(false)} lessons={lessons} title="Sua equipe" />
    </>
  );
}

export default TeamTutorialBanner;
